import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clipNumber'
})
export class ClipNumberPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return null;
  }
}
